import { executeRequest, JFSRequest } from '@jfs/network'
import { actionMenuStrings } from '../data/static/strings'
import { RootStore } from '../data/store'
import { updateEndDateTimeInRequest } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const exportVaultReport = (tokens: any, reqBody: any) => {
  const isCustomRange =
    RootStore.tokenizationRequests.selectedDate.dateLabel === actionMenuStrings.customDate ||
    RootStore.tokenizationRequests.selectedDate.dateLabel === actionMenuStrings.yesterday
  const request: JFSRequest<{}> = {
    apiPath: `${sitConfig(tokens).baseUrl}${APIEndPoints.getDownloadVaultReport}`,
    method: 'POST',
    responseType: 'arraybuffer',
    config: sitConfig(tokens),
    headers: sitConfig(tokens).headers,
    body: isCustomRange ? reqBody : updateEndDateTimeInRequest(reqBody),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { exportVaultReport }
